import { render, staticRenderFns } from "./button.vue?vue&type=template&id=b929a554&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b929a554')) {
      api.createRecord('b929a554', component.options)
    } else {
      api.reload('b929a554', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=b929a554&", function () {
      api.rerender('b929a554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/button/button.vue"
export default component.exports